import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { transport } from '../../../../utils/constants';
import { getToken } from '../../../../utils/helper';
import { ITransactionsProps } from '../../types';
import { TransactionItem } from '../TransactionItem/TransactionItem';
import { WalletClient } from '../../../../generated/mlmbox/client/finance/wallet.client';
import { Sort_Direction } from '../../../../generated/mlmbox/types/sort';
import { Wallet_Asset_Transaction } from '../../../../generated/mlmbox/types/wallet';

export const Transactions = (props: ITransactionsProps) => {
    const [transactionList, setTransactionList] = useState<Map<string, Wallet_Asset_Transaction[]>>(new Map());
    const [transactionListMain, setTransactionListMain] = useState<Wallet_Asset_Transaction[]>([]);
    const [transactionId, setTransactionId] = useState<number | null>();

    const [fetching, setFetching] = useState(true);
    const [fetching2, setFetching2] = useState(true);
    const { t } = useTranslation();

    const months = [
        t('month.jan'),
        t('month.feb'),
        t('month.mar'),
        t('month.apr'),
        t('month.may'),
        t('month.jun'),
        t('month.jul'),
        t('month.aug'),
        t('month.sep'),
        t('month.oct'),
        t('month.nov'),
        t('month.dec'),
    ];

    function groupedTransitions(transactions: Wallet_Asset_Transaction[]): Map<string, Wallet_Asset_Transaction[]> {
        const result: Map<string, Wallet_Asset_Transaction[]> = transactions.reduce((acc, transaction) => {
            let { createdAt } = transaction;
            createdAt = createdAt * 1000;

            const year = new Date(createdAt).getFullYear();
            const monthIndex = new Date(createdAt).getMonth();
            const day = new Date(createdAt).getDate();

            const todayMonthIndex = new Date().getMonth();
            const todayYear = new Date().getFullYear();
            const todayDay = new Date().getDate();
            const today = todayYear === year && todayMonthIndex === monthIndex && todayDay === day;

            const todayDate = new Date(); // Текущая дата
            const yesterday = new Date(todayDate); // Копируем текущую дату

            yesterday.setDate(todayDate.getDate() - 1);

            const yesterdayMonthIndex = yesterday.getMonth();
            const yesterdayYear = yesterday.getFullYear();
            const yesterdayDay = yesterday.getDate();
            const yesterdayDate = yesterdayYear === year && yesterdayMonthIndex === monthIndex && yesterdayDay === day;

            const date = today ? 'Сегодня' : yesterdayDate ? 'Вчера' : `${day} ${months[monthIndex]} ${year}`;
            if (acc.has(date)) {
                acc.get(date).push(transaction);
            } else {
                acc.set(date, [transaction]);
            }
            return acc;
        }, new Map());
        setFetching2(false);
        return result;
    }

    function loadTransactions() {
        if (fetching2) return;
        const walletClient = new WalletClient(transport);

        setFetching2(true);

        walletClient
            .assetTransactionList(
                {
                    assetId: props.assetId,
                    sortTransactions: {
                        direction: Sort_Direction.BACKWARD,
                        limit: 50,
                    },
                    stepTransactionId: transactionId ? transactionId : 0,
                    filterKindIds: [],
                },
                { meta: { authorization: getToken() } }
            )
            .then(({ status, response }) => {
                if (status.code === 'OK') {
                    setTransactionListMain((prev) => [...prev, ...response.items]);
                    response.items.length ? setTransactionId(response.items[response.items.length - 1].transactionId) : setTransactionId(0);

                    props.setVisible(false);
                    props.setReload(false);
                    setFetching(false);
                }
            });
    }

    useEffect(() => {
        setFetching2(true);
        const walletClient = new WalletClient(transport);

        walletClient
            .assetTransactionList(
                {
                    assetId: props.assetId,
                    sortTransactions: {
                        direction: Sort_Direction.BACKWARD,
                        limit: 50,
                    },
                    filterKindIds: [],
                    stepTransactionId: 0,
                },
                { meta: { authorization: getToken() } }
            )
            .then(({ status, response }) => {
                if (status.code === 'OK') {
                    setTransactionListMain(() => response.items);
                    response.items.length ? setTransactionId(response.items[response.items.length - 1].transactionId) : setTransactionId(0);

                    setFetching(false);
                    props.setReload(false);
                }
            });
    }, [props.assetId, props.reload]);

    useEffect(() => {
        if (fetching) return;
        if (transactionListMain.length) {
            setTransactionList(groupedTransitions(transactionListMain));
        } else {
            // props.setVisible(true);
            props.setVisible(false);
            setFetching(false);
            setFetching2(false);
        }
    }, [transactionListMain]);

    useEffect(() => {
        if (transactionList.size > 0) {
            setFetching(false);
            props.setVisible(false);
        }
    }, [transactionList]);

    const observer = useRef<IntersectionObserver>();
    const obserevItem = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if ((transactionId && transactionId <= 1) || transactionListMain.length < 49) {
            observer.current?.disconnect();

            return;
        }

        if (observer.current) {
            observer.current.disconnect();
        }

        observer.current = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    loadTransactions();
                }
            });
        });

        if (obserevItem?.current) {
            observer.current.observe(obserevItem.current);
        }

        return () => {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
    }, [transactionList]);

    return (
        <div
            className="transactions"
            onScroll={() => console.log('scroll')}>
            {/* {fetching && (
                <div className="main-spinner">
                    <div className="spinner"></div>
                </div>
            )} */}
            {!props.visible && !fetching && Array.from(transactionList).length === 0 && !fetching && (
                <div className="empty">
                    <p>{t('wallet.transactions.empty')}</p>
                </div>
            )}
            {!fetching && (
                <>
                    {Array.from(transactionList).map((el) => (
                        <div className="inner">
                            <div
                                className="header"
                                key={el[0]}>
                                <h1>{el[0]}</h1>
                            </div>
                            <div className="transaction-items">
                                {el[1].map((el) => (
                                    <TransactionItem
                                        {...el}
                                        assetId={props.assetId}
                                        key={el.transactionId + '-' + props.assetId}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </>
            )}
            <div
                style={{ marginTop: '-24px', height: '30px' }}
                className="observe-item"
                ref={obserevItem}>
                {fetching2 && <div className="spinner small"></div>}
            </div>
        </div>
    );
};
